"use client"

import { Button } from "@/shared/components/ui/button"
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/shared/components/ui/dialog"
import { SlidersHorizontal } from "lucide-react"
import React, { useState, memo } from "react"
import PriorityFilterForm from "./priority-filter-form"
import { useIsMobile } from "@/shared/hooks/use-mobile"

const PriorityFilterButton = memo(function PriorityFilterButton() {
  const [isOpen, setIsOpen] = useState(false)
  const isMobile = useIsMobile()

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          variant="default"
          size="sm"
          className="shrink-0 bg-primary hover:bg-primary/90 text-white font-bold rounded-md gap-2 py-1 h-8"
        >
          <SlidersHorizontal className="h-4 w-4" />
          {!isMobile && <span>Filter</span>}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="max-h-[90vh] max-w-3xl"
        onInteractOutside={(e) => {
          const target = e.target as HTMLElement
          if (target?.closest?.("[data-avoid-dialog-close], [data-radix-popper-content-wrapper]")) {
            e.preventDefault()
          }
        }}
        onFocusOutside={(e) => {
          const target = e.target as HTMLElement
          if (target?.closest?.("[data-avoid-dialog-close], [data-radix-popper-content-wrapper]")) {
            e.preventDefault()
          }
        }}
      >
        <DialogTitle>Filter Priority Matrix</DialogTitle>
        <div className="overflow-y-auto max-h-[calc(90vh-120px)] pr-4">
          {isOpen && (
            <PriorityFilterForm onSuccessCallback={() => setIsOpen(false)} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
})

export default PriorityFilterButton
